import { FC } from "react";
import { CartesianGrid, Legend, Tooltip, XAxis, YAxis } from "recharts";

import { DefaultChartProps } from "./types.ts";

export const SharedChartOptions: FC<DefaultChartProps> = ({ displayLegend, displayTooltip, xAxisDataKey }) => {
    return (
        <>
            <XAxis axisLine={false} dataKey={xAxisDataKey} />
            <CartesianGrid vertical={false} strokeDasharray="12" opacity={0.4} />
            <YAxis axisLine={false} />
            {displayLegend ? <Legend verticalAlign={"top"} height={40} /> : null}
            {displayTooltip ? <Tooltip /> : null}
        </>
    );
};
